import { Twitter, Linkedin, Youtube, Github } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface SocialLinksProps {
  className?: string;
  iconSize?: "sm" | "md" | "lg";
  showLabels?: boolean;
}

// Update these with your actual social media URLs
const SOCIAL_LINKS = {
  twitter: "https://twitter.com/lineroidfeeds",
  linkedin: "https://linkedin.com/company/lineroid",
  youtube: "https://youtube.com/@lineroid",
  github: "https://github.com/lineroid",
};

const iconSizes = {
  sm: "h-4 w-4",
  md: "h-5 w-5",
  lg: "h-6 w-6",
};

export function SocialLinks({ 
  className = "", 
  iconSize = "md",
  showLabels = false 
}: SocialLinksProps) {
  const size = iconSizes[iconSize];

  const links = [
    { 
      name: "Twitter", 
      icon: Twitter, 
      url: SOCIAL_LINKS.twitter,
      label: "Follow us on X"
    },
    { 
      name: "LinkedIn", 
      icon: Linkedin, 
      url: SOCIAL_LINKS.linkedin,
      label: "Connect on LinkedIn"
    },
    { 
      name: "YouTube", 
      icon: Youtube, 
      url: SOCIAL_LINKS.youtube,
      label: "Subscribe on YouTube"
    },
    { 
      name: "GitHub", 
      icon: Github, 
      url: SOCIAL_LINKS.github,
      label: "View on GitHub"
    },
  ];

  if (showLabels) {
    return (
      <div className={`flex flex-wrap gap-4 ${className}`}>
        {links.map((link) => (
          <a
            key={link.name}
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 text-muted-foreground hover:text-foreground transition-colors"
            aria-label={link.label}
          >
            <link.icon className={size} />
            <span className="text-sm">{link.name}</span>
          </a>
        ))}
      </div>
    );
  }

  return (
    <TooltipProvider>
      <div className={`flex items-center gap-1 ${className}`}>
        {links.map((link) => (
          <Tooltip key={link.name}>
            <TooltipTrigger asChild>
              <a
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 rounded-lg hover:bg-muted transition-colors text-muted-foreground hover:text-foreground"
                aria-label={link.label}
              >
                <link.icon className={size} />
              </a>
            </TooltipTrigger>
            <TooltipContent>{link.label}</TooltipContent>
          </Tooltip>
        ))}
      </div>
    </TooltipProvider>
  );
}
